var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.bg),function(item,index){return _c('img',{key:index,staticClass:"bg-imgs",class:{
                'blockImg':index == _vm.selectIndex ,
                'currentImg':index == _vm.selectIndex && _vm.timer ,
                'nextImg':(_vm.selectIndex+1)%_vm.bg.length==index && _vm.timer 
            },attrs:{"src":item}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cd8d50a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/a.header.img.leftright.vue
// module id = A1LY
// module chunks = 0